const fieldExcelSsCreation = [
    {colMd: "6", required: true, label: "Country", type: "select", name: "country_id"},
    {colMd: "6", required: true, label: "Excel File", type: "file", name: "excel_file", file_type: ".xlsx, .xls", tagline: "Please populate downloaded Template File and upload it otherwise SS creation will fail or info will be wrongly filled."}
];

export {
    fieldExcelSsCreation
};